module.exports = __webpack_public_path__ + "img/icon_5_69.c15409f1.png";